import React from "react";
import { Button,Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function observation({ nextStep, prevStep }) {
  return (
    <>
    <div className="form-navigator-body">
      <Table bordered >
        <thead>
          <tr className="table-secondary text-center align-middle">
            <th>Name of the Position</th>
            <th>Sanctioned</th>
            <th>In Place</th>
            <th>No Vacant</th>
            <th style={{ whiteSpace: "pre-line"}}>Vacant since 
              {"\n"}(dd/mm/yyyy)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>District AIDS Control Officer (DACO)</td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="date" className=" text-center mr-2"/></td>
          </tr>

          <tr>
            <td>District Programme Manager (DPM)</td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td className="table-secondary">Not Applicable</td>
            <td className="table-secondary">Not Applicable</td>
          </tr>

          <tr>
            <td>Cluster Programme Manager (CPM)</td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="date" className=" text-center"/></td>
          </tr>

          <tr>
            <td>Cluster Prevention Officer (CPO) </td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="date" className=" text-center"/></td>
          </tr>

          <tr>
            <td>District ICTC Supervisor (DIS)</td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td className="table-secondary">Not Applicable</td>
            <td className="table-secondary">Not Applicable</td>
          </tr>

          <tr>
            <td>Clinical Service Officer (CSO)</td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="date" className=" text-center"/></td>
          </tr>

          <tr>
            <td>District Assistant- Monitoring & Evaluation (DA-M&E)</td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td className="table-secondary">Not Applicable</td>
            <td className="table-secondary">Not Applicable</td>
          </tr>

          <tr>
            <td>District Assistant- Accounts (DA-Accounts)</td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td className="table-secondary">Not Applicable</td>
            <td className="table-secondary">Not Applicable</td>
          </tr>

          <tr>
            <td>District Assistant- Programme (DA-Programme)</td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td className="table-secondary">Not Applicable</td>
            <td className="table-secondary">Not Applicable</td>
          </tr>

          <tr>
            <td>Data Monitoring & Documentation Officer (DMDO)</td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="text" className=" text-center" placeholder="Please Enter"/></td>
            <td><input type="date" className=" text-center"/></td>
          </tr>

          <tr>
            <td>Remarks</td>
            <td colSpan={4}><input type="text" className=""/></td>
          </tr>
        </tbody>
      </Table>
    </div>


      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
